import { useAuth } from '@forwardflow/context/AuthContext'
import { useGetOrganizationList } from '@forwardflow/hooks/customHooks/organizationList'
import { useUserNavigation } from '@forwardflow/hooks/customHooks/useUserNavigation'
import LocalStorage from '@forwardflow/services/LocalStorage'
import { isOperatorEmail } from '@forwardflow/utils/app.utils'
import { message, Select } from 'antd'
import { useEffect, useState } from 'react'

export const SelectOperatorOrganization = () => {
   const { navigateUser } = useUserNavigation()
   const [organizationParams, setOrganizationParams] = useState({
      page: 1,
      limit: 10,
   })

   const { auth } = useAuth()

   const shouldFetch = isOperatorEmail(auth.user?.email || '')
   const { data: organizationList, isLoading } = useGetOrganizationList({
      ...organizationParams,
      shouldFetch,
   })
   const [allOrganizations, setAllOrganizations] = useState<any[]>([])

   const organizationOptions = allOrganizations?.map((item) => {
      return {
         value: item.id,
         label: item.organizationName + ' - ' + item.id,
      }
   })

   const selectedOrganization = LocalStorage.get(
      'currentOrganization'
   ) as string

   const onSelectOrganization = async (value: string) => {
      try {
         LocalStorage.put('currentOrganization', value)
         message.success('Organization changed successfully')
         setTimeout(async () => {
            await navigateUser({
               currentOrgId: value,
               searchParams: location.search,
            })
         }, 1000)
      } catch (error) {
         console.log('error', error)
      }
   }

   const loadMoreOrganizations = () => {
      setOrganizationParams((prev) => ({
         ...prev,
         page: prev.page + 1,
      }))
   }

   useEffect(() => {
      if (organizationList && organizationList.length > 0) {
         setAllOrganizations((prev) => {
            const combined = [...prev, ...organizationList]
            return Array.from(
               new Map(combined.map((item) => [item.id, item])).values()
            )
         })
      }
   }, [organizationList])

   return (
      <Select
         className="ml-[10px] w-[120px] lg:w-[200px] dashboard-select"
         placeholder="Select Organization"
         options={organizationOptions}
         onChange={onSelectOrganization}
         value={selectedOrganization || ''}
         loading={isLoading}
         onPopupScroll={(e) => {
            const target = e.target as HTMLDivElement
            if (
               target.scrollTop + target.offsetHeight >=
               target.scrollHeight - 20
            ) {
               loadMoreOrganizations()
            }
         }}
      />
   )
}
